<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" label-position="right" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="单据号" prop="documentNo">
                    <el-input v-model="queryCondition.documentNo" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="报告期限从" prop="monthFrom">
                    <el-date-picker v-model="queryCondition.monthFrom" value-format="yyyy-MM" format="yyyy-MM" type="month" style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="报告期限至" prop="monthTo">
                    <el-date-picker v-model="queryCondition.monthTo" value-format="yyyy-MM" format="yyyy-MM" type="month" style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Category3" prop="category3Code">
                    <el-select :disabled="isDisabled" v-model="queryCondition.category3Code" clearable style="width:100%">
                      <el-option :key="index" v-for="(item,index) in category3CodeOptions" :label="item.object" :value="item.key"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="供应商" prop="sponsorName">
                      <el-input v-model="queryCondition.sponsorName" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="状态" prop="status">
                      <ic-select v-model="queryCondition.status" table="TT_RMC_PROTEIN_PURCHASE" field="STATUS" :excludes="excludesValue" clearable placeholder="请选择" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="small" class="btn" type="primary" @click="onAdd" v-acl="RMC_PROT_PCQTY_ADD" v-if="ms_roles.indexOf('QSPI_RMC_CHICK_BUYER_SUPP')!==-1||ms_roles.indexOf('QSPI_RMC_PORK_BUYER_SUPP')!==-1">新增</el-button>
        <el-button size="small" class="btn" type="danger" @click="onDel" v-acl="RMC_PROT_PCQTY_DELETE" v-if="ms_roles.indexOf('QSPI_RMC_CHICK_BUYER_SUPP')!==-1||ms_roles.indexOf('QSPI_RMC_PORK_BUYER_SUPP')!==-1">删除</el-button>
        <el-button size="small" class="btn" type="danger" @click="onAdminDel" v-acl="RMC_PROT_PCQTY_ADMIN_DELETE">删除</el-button>
        <el-button size="small" class="btn" type="primary" @click="onExport" v-acl="RMC_PROT_PCQTY_REPORT">导出</el-button>
      </el-row>
      <ux-grid ref="plxTable" :data="tableData" @selection-change="selectionChange" max-height="600" show-overflow="tooltip" highlight-current-row>
        <ux-table-column align="center" type="checkbox" width="80" />
        <ux-table-column align="center" title="单据号" resizable min-width="100" field="documentNo">
          <template v-slot="{ row }">
            <el-button type="text" @click="onDetail(row)">{{row.documentNo}}</el-button>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="报告期限" resizable min-width="90" field="month"></ux-table-column>
        <ux-table-column align="center" title="Category3" resizable min-width="100" field="category3Name"></ux-table-column>
        <ux-table-column align="center" title="供应商" resizable min-width="90" field="sponsorName"></ux-table-column>
        <ux-table-column align="center" title="状态" resizable min-width="120" field="statusI18n"></ux-table-column>
        <ux-table-column align="center" title="更新人" resizable min-width="90" field="updateName"></ux-table-column>
        <ux-table-column align="center" title="更新时间" resizable min-width="120" field="updateDate"></ux-table-column>
      </ux-grid>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
        </el-pagination>
      </div>
      <el-dialog title="请选择" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false" @close="onCancelExport" class="fpa">
        <el-form ref="exportForm" :model="exportForm" :rules="exportFormRules" label-width="80px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="年" prop="yearStr">
                <el-date-picker v-model="exportForm.yearStr" value-format="yyyy" format="yyyy" type="year" placeholder="选择年" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Category3" prop="category3Code">
                <el-select v-model="exportForm.category3Code" clearable placeholder="请选择" style="width:100%">
                  <el-option :key="index" v-for="(item,index) in category3CodeLists" :label="item.object" :value="item.key"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-row type="flex" justify="center">
          <el-button size="mini" @click="onDownload" type="primary">导出</el-button>
          <el-button size="mini" @click="onCancelExport">取消</el-button>
        </el-row>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import store from '@/store/index'
import IcSelect from "@/components/common/icSelect";
import rmcProtPurchaseApi from "@/api/rmcProtein/purchase";
import paginationMixin from '@/mixins/pagitionMixin';
import commonFunction from "@/utils/dataTableUtils";
import { fileService } from "@/api/common/file-utils";
export default {
  name: 'rmcProtPurchase',
  mixins: [paginationMixin],
  components: {
    IcSelect,
  },
  data() {
    return {
      multipleSelection: [],
      idList: [],
      category3CodeOptions: [],
      category3CodeLists: [],
      excludesValue: [],
      tableData: [],
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        documentNo: "",
        monthFrom: "",
        monthTo: "",
        category3Code: "",
        sponsorName: "",
        status: "",
      },
      exportForm: {
        yearStr: "",
        category3Code: "",
      },
      exportFormRules: {
        yearStr: [
          { required: true, message: "请选择年份", trigger: "change" }
        ],
        category3Code: [
          { required: true, message: "请选择Category3", trigger: "change" }
        ]
      },
      isShow: false,
      dialogUpdateVisible: false,
      isDisabled: false,
      dialogVisible: false,
      totalCount: 0,
      pages: 1,
      ms_roles: null,
      ms_userId: null,
      ms_Permission: null,
    }
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  beforeRouteEnter(to, from, next) {
    console.log("tototot", to)
    if (from.path === '/qspiTodo' && to.query.month) {
      to.meta.reqData.monthFrom = to.query.month
      to.meta.reqData.monthTo = to.query.month
    }
    if (from.path === '/qspiTodo' && to.query.status) {
      to.meta.reqData.status = to.query.status
    }
    if (from.path === '/qspiTodo' && to.query.sponsorName) {
      to.meta.reqData.sponsorName = to.query.sponsorName
    }
    // if (from.path === '/rmcProtASL' && to.query.category3Code) {
    //   to.meta.reqData.category3Code = to.query.category3Code
    // }
    if (from.path === '/rmcProtASL' && to.query.sponsorName) {
      to.meta.reqData.sponsorName = to.query.sponsorName
    }
    rmcProtPurchaseApi.findListPage(to.meta.reqData).then((res) => {
      next(vm => {
        vm.queryCondition = to.meta.reqData;
        vm.tableData = res.data.records;
        vm.totalCount = res.data.total;
      })
    })
  },
  destroyed() {
    this.$store.dispatch('saveQueryData', {})
  },
  created() {
    this.ms_roles = JSON.parse(localStorage.getItem('ms_roles'))
    this.ms_Permission = JSON.parse(localStorage.getItem('ms_Permission'))
    this.ms_userId = JSON.parse(localStorage.getItem('ms_userId'))
    console.log("this.ms_roles", this.ms_roles.indexOf('QSPI_RMC_PROTEIN_CQS') !== -1);
    if (this.ms_Permission.indexOf('RMC_PROT_PCQTY_CQS') !== -1 && this.ms_Permission.indexOf('RMC_PROT_PCQTY_ADMIN_DELETE') === -1) {
      this.excludesValue.push('DRAFT')
    }
    this.getSelection()
  },
  methods: {
    queryData() {
      rmcProtPurchaseApi.findListPage(this.queryCondition).then(res => {
        this.tableData = res.data.records;
        this.totalCount = res.data.total;
        this.pages = res.data.pages;
        this.$refs.plxTable.reloadData(res.data.records)
      });
    },
    getSelection() {
      rmcProtPurchaseApi.getSelection(['rmc.RmcCategory3']).then(res => {
        console.log('获取下拉框', res);
        this.category3CodeLists = res.data['rmc.RmcCategory3'].filter((v) => {
          return v.cascadeKey === 'protein'
        })
        if (this.ms_roles.indexOf('QSPI_RMC_PROTEIN_CQS') !== -1) {
          this.category3CodeOptions = res.data['rmc.RmcCategory3'].filter((v) => {
            return v.cascadeKey === 'protein'
          })
        } else {
          if (this.ms_Permission.indexOf('RMC_DATAPERM_PORK') !== -1 && this.ms_Permission.indexOf('RMC_DATAPERM_POULTRY') !== -1) {
            this.category3CodeOptions = res.data['rmc.RmcCategory3'].filter((v) => {
              return v.cascadeKey === 'protein'
            })
          }
          if (this.ms_Permission.indexOf('RMC_DATAPERM_POULTRY') !== -1 && this.ms_Permission.indexOf('RMC_DATAPERM_PORK') === -1) {
            this.category3CodeOptions = res.data['rmc.RmcCategory3'].filter((v) => {
              return v.cascadeKey === 'protein'
            }).filter(ele => {
              return ele.object === 'Poultry'
            })
          }
          if (this.ms_Permission.indexOf('RMC_DATAPERM_PORK') !== -1 && this.ms_Permission.indexOf('RMC_DATAPERM_POULTRY') === -1) {
            this.category3CodeOptions = res.data['rmc.RmcCategory3'].filter((v) => {
              return v.cascadeKey === 'protein'
            }).filter(ele => {
              return ele.object === 'Pork'
            })
          }
        }
        if (this.category3CodeOptions.length === 1) {
          this.$set(this.queryCondition, 'category3Code', this.category3CodeOptions[0].key)
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      });
    },
    selectionChange(val) {
      this.multipleSelection = val;
      this.idList = []
      val.forEach(ele => {
        this.idList.push(ele.ttRmcProteinPurchaseId)
      })
    },
    onAdd() {
      this.$router.push({
        path: '/rmcProtPcQty/detail',
        query: {
          from: 'add'
        }
      })
    },
    onDel() {
      if (this.idList.length == 0) {
        this.$message.error('请先选择数据后再操作');
        return false
      }
      var flag = this.multipleSelection.every(ele => {
        return ele.status == 'DRAFT'
      })
      if (!flag) {
        this.$message.error("已选中的信息不是草稿状态，无法删除！");
        return false
      }
      var isValid = this.multipleSelection.every(ele => {
        return this.ms_userId === ele.createBy
      })
      if (!isValid) {
        this.$message.error("无权限，仅可操作自己维护的单据！");
        return false
      }
      console.log('isValid', isValid);
      //您确定要删除所选记录吗？
      this.$confirm('请确认是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'colorBtn',
        cancelButtonClass: 'btn_custom_cancel',
        type: 'warning'
      }).then(() => {
        this.$set(this.queryCondition, 'ttRmcProteinPurchaseIdList', this.idList)
        rmcProtPurchaseApi.beatchDeletePurchase(this.queryCondition).then(res => {
          console.log('res', res);
          if (res.meta.code === 200) {
            this.$message.success("删除成功");
            this.idList = []
            this.queryData()
          }
        });
      })
    },
    onAdminDel() {
      if (this.idList.length == 0) {
        this.$message.error('请先选择数据后再操作');
        return false
      }
      //您确定要删除所选记录吗？
      this.$confirm('请确认是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'colorBtn',
        cancelButtonClass: 'btn_custom_cancel',
        type: 'warning'
      }).then(() => {
        this.$set(this.queryCondition, 'ttRmcProteinPurchaseIdList', this.idList)
        rmcProtPurchaseApi.beatchDeletePurchase(this.queryCondition).then(res => {
          console.log('res', res);
          if (res.meta.code === 200) {
            this.$message.success("删除成功");
            this.idList = []
            this.queryData()
          }
        });
      })
    },
    onExport() {
      this.dialogVisible = true
      this.$refs['exportForm'].resetFields()
    },
    onDownload() {
      this.$refs['exportForm'].validate((valid) => {
        if (valid) {
          rmcProtPurchaseApi.rmcProteinPurchaseDownload(this.exportForm).then(res => {
            var arr = this.category3CodeLists.filter(ele => {
              return ele.key === this.exportForm.category3Code
            })
            var category3Code = arr[0].object
            fileService.respToFile(res, 'Sourcing Volume Breakdown_' + category3Code + '_' + this.exportForm.yearStr + '.xlsx');
          });
        }
      })
    },
    onCancelExport() {
      this.dialogVisible = false
      this.exportForm = {
        yearStr: "",
        category3Code: "",
      }
    },
    onDetail(row) {
      this.$router.push({
        path: '/rmcProtPcQty/detail',
        query: {
          ttRmcProteinPurchaseId: row.ttRmcProteinPurchaseId,
          from: 'edit'
        }
      })
    },
    onSearch() {
      this.queryCondition.pageNum = 1
      this.queryCondition.pageSize = 15
      this.queryData()
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
    onReset() {
      this.$refs['queryCondition'].resetFields()
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        documentNo: "",
        monthFrom: "",
        monthTo: "",
        category3Code: "",
        sponsorName: "",
        status: "",
      }
      this.queryData();
    },
  },
  extends: commonFunction
}
</script>
<style scoped >
</style>
